import memCacheWithTTL from "@utils/memCacheWithTTL";

export const ssrCache = memCacheWithTTL({});
